export enum GlobalSearchRoutesType {
  dashboard = '/dashboard',
  events = '/dashboard/events',
  notes = '/dashboard/notes',
}
